import React, { useState } from 'react';
import ac from './image/ac.jpeg';
import clean from '../video/bgsaf.avif';
import paint from '../video/paintbg1.avif';
import plum from "../video/plumbg.avif";
// import webdev from './image/webdev.jpg'; // Add a relevant image
import './portfolio.css'
const services = [
  {
    id: 1,
    title: "Appliance Repair",
    description: "Certified experts for appliances.",
    image: ac,
    category: "repair",
    size: "large",
  },
  {
    id: 2,
    title: "Home Painting",
    description: "Eco-friendly interior & exterior painting.",
    image: paint,
    category: "painting",
    size: "medium",
  },
  {
    id: 3,
    title: "Plumbing Services",
    description: "Fast leak repair & drain cleaning.",
    image: plum,
    category: "plumbing",
    size: "small",
  },
  {
    id: 4,
    title: "Home Cleaning",
    description: "Deep clean or regular housekeeping.",
    image: clean,
    category: "cleaning",
    size: "small",
  },
 
  {
    id: 5,
    title: 'Web Development',
    description: 'Build modern websites for your service business.',
    image: 'https://static.vecteezy.com/system/resources/previews/035/506/086/non_2x/web-development-coding-programming-internet-technology-business-concept-young-man-using-computer-with-web-development-icon-on-vr-screen-photo.jpg',
    category: 'web',
  },
  {
    id: 6,
    title: 'UI/UX Design',
    description: 'User-friendly and attractive interfaces for websites or apps.',
 image:'https://png.pngtree.com/background/20211216/original/pngtree-mobile-ui-ux-development-purple-design-concept-picture-image_1531010.jpg',
    category: 'web',
  },
  {
    id: 7,
    title: 'SEO Optimization',
    description: 'Boost your online visibility with SEO best practices.',
     image:'https://i.pinimg.com/originals/9e/dd/33/9edd33e79dd9c618bfd9c931a1376c6b.jpg',
    category: 'web',
  },
  {
    id: 8,
    title: 'AC Installation',
    description: 'Professional AC installation and servicing.',
    image:'https://www.absoluteairflow.com/wp-content/uploads/2024/03/shutterstock_1498805060.jpg', 
    category: 'repair',
  },
  {
    id: 9,
    title: 'Bathroom Renovation',
    description: 'Modernize your bathroom with plumbing and tiling solutions.',
    image: 'https://tse1.mm.bing.net/th/id/OIP.StHghA6WWaVfiwkLPecpdwAAAA?rs=1&pid=ImgDetMain&o=7&rm=3', 
    category: 'plumbing',
  },
  {
    id: 10,
    title: 'Post-Construction Cleaning',
    description: 'Remove dust and debris after renovation or construction work.',
    image:'https://momentumbsla.com/wp-content/uploads/2022/03/post-construction-cleaning-03.jpg',
    category: 'cleaning',
  },
 
{
  id: 11,
  title: "Video Graphics",
  description: "Create engaging promo and explainer videos.",
image:'https://breadnbeyond.com/wp-content/uploads/2023/04/Benefits-of-Videographics-2.jpg.jpg' ,
  category: "graphics",
  size: "large",
},
{
  id: 12,
  title: "Photo Graphics",
  description: "Professional photo editing and graphic design.",
 image:'https://static.vecteezy.com/system/resources/thumbnails/033/068/090/small_2x/watercolor-camera-isolated-colorful-graphics-photo.jpg' ,
  category: "graphics",
  size: "medium",
}

];

const categories = ['all', 'repair', 'painting', 'plumbing', 'cleaning', 'web','graphics'];

export default function PortfolioSection() {
  const [activeFilter, setActiveFilter] = useState('all');

  const filteredItems =
    activeFilter === 'all'
      ? services
      : services.filter((item) => item.category === activeFilter);

  return (
    <section className="portfolio-section py-5 bg-light" id="portfolio">
      <div className="container">
        <div className="text-center mb-5">
          <h2>Our Service Portfolio</h2>
          <p>Filter and explore the services we offer</p>
        </div>

        <div className="filter-buttons text-center mb-4">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`btn mx-2 filter-btn ${activeFilter === cat ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setActiveFilter(cat)}
            >
              {cat.charAt(0).toUpperCase() + cat.slice(1)}
            </button>
          ))}
        </div>

        <div className="row">
          {filteredItems.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6 mb-4">
             <div className="portfolio-item">
  <div className="portfolio-image-container">
    <img src={item.image} alt={item.title} className="portfolio-image" />
    <div className="portfolio-overlay">
      <div className="portfolio-content">
        <h4>{item.title}</h4>
        <p>{item.description}</p>
      </div>
    </div>
  </div>
</div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
